import * as d3 from "d3";
import {
    make_x_gridlines,
    make_y_gridlines,
    colonAnnotation,
    fw_progressive_1way,
    responsivefy,
    // tooltip_class,
    getTimeFormatter, createTooltip, inrFormatterV2
} from '../functions'

export default function (chart, divId, vizName,resData, filterParam, checkbox, gridflag) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar

    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId)
        .append('svg')
        .attr('width', chart.width + chart.margin.left + chart.margin.right)
        .attr('height', chart.height + chart.margin.top + chart.margin.bottom)
        .call(responsivefy)
        .append('g')
        .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

    // Add <defs> and <clipPath> to the SVG
    svg.append("defs")
        .append("svg:clipPath")
        .attr("id", "clip1")  // Use d.key for the clipPath id
        .append("svg:rect")
        .attr("x", 0)
        .attr("y", -10)
        .attr("width", chart.width)   // Clip width matches chart width
        .attr("height", chart.height+10); // Clip height matches chart height

    // Append a group with clipPath applied
    const contentGroup = svg.append("g")
        .attr("class", "content")
        .attr("clip-path", "url(#clip1)");  // Dynamically set clip-path using d.key

    // axios.post(url, filterParam).then(response => {
        let data = resData
        // nest function allows to group the calculation per level of a factor
        var sumstat = d3.nest().key(d => {
            return d.dim1_name
        }).sortKeys(d3.ascending).entries(data)
        // Add X-axis for date and Y-axis
        // Parse date strings into Date objects
        data.forEach(function(d) {
            d.dim2_name = new Date(d.dim2_name);
            console.log("kkk",d.dim2_name)
        });

// Create time scale
        var x1Scale = d3.scaleTime()
            .range([0, chart.width])

        const dim4Names = data.map(d => d.dim3_name);
        const firstDim4Name = dim4Names[0];
        var formatTime = getTimeFormatter(firstDim4Name)

        x1Scale.domain(d3.extent(data, function(d) { return d.dim2_name; }));


        var y1Scale = d3.scaleLinear().domain([(function() {
            var minVal = d3.min(data, function(d) {
                return d.metric1;
            });
            return (minVal < 0) ? minVal : 0;
        })(), d3.max(data, d => {
            return d.metric1
        })]).range([chart.height, 0])

        svg.append('g')
            .attr('transform', 'translate(0,' + chart.height + ')')
            .attr("class","x-axis")
            .call(d3.axisBottom(x1Scale).tickFormat(formatTime).ticks(d3.timeMonth.every(1)))
            //.call(d3.axisBottom(x1Scale))
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .style('text-anchor', 'end')
            .attr('dx', '-.6em')
            .attr('dy', '-.0em')
            .attr('transform', 'rotate(-60)')

        svg.append('text')
            .attr('x', (chart.width / 2.5))
            .attr('y', chart.height + chart.margin.bottom - chart.margin.top - 30 )
            .style('fill', fontColor)
            .text(chart.x1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y',0-(chart.margin.right/2) )
            .attr('x', 0 - (chart.height / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append('g')
            .attr("class","y-axis")
            .call(d3.axisLeft(y1Scale).tickFormat(function (d){
                return inrFormatterV2(d,chart.data.menuId)
            }))
            .selectAll('text')
            .style('font-size', axisLabelFontSize)

        if (gridflag == true) {
            // add the X gridlines
            svg.append("g")
                .attr("class", "grid")
                .attr("transform", "translate(0," + chart.height + ")")
                .call(make_x_gridlines(x1Scale).ticks(d3.timeMonth.every(1))
                    .tickSize(-chart.height)
                    .tickFormat(""))
                .style("stroke-width", 0.1)

            // add the Y gridlines
            svg.append("g")
                .attr("class", "grid")
                .call(make_y_gridlines(y1Scale)
                    .tickSize(-chart.width)
                    .tickFormat(""))
                .style("stroke-width", 0.1)
        }

        // color palette
        var res = sumstat.map(d => {
            return d.key
        }) // list of group main category
        var metric1ColorScale = d3.scaleOrdinal().domain(res).range(fw_progressive_1way)

        // Draw the line
        contentGroup.selectAll('.line')
            .data(sumstat)  // Binds data to the line
            .join("path")
            .attr("class", "line")
            .attr('fill', 'none')
            .attr('stroke', d => {
                return metric1ColorScale(d.key)
            })
            .attr('stroke-width', 3)
            .attr('d', (d) => {
                let line = d3.line()
                    .x(d => {
                        return x1Scale(d.dim2_name)
                    })
                    .y(d => {
                        return y1Scale(+d.metric1)
                    })

                return line(d.values)
            })
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding


        const tooltip = createTooltip(divId);


        contentGroup.selectAll(".dot")
            .data(data)
            .join("circle")
            .attr("class","dot")
            .attr("r", 5)
            .attr("cx", function (d) {
                return x1Scale(d.dim2_name);
            })
            .attr("cy", function (d) {
                return y1Scale(d.metric1);
            })
            .style("fill", d => {
                return metric1ColorScale(d.dim1_name)
            })
            .on('mouseover', function(d) {
                const fontColor = metric1ColorScale(d.dim1_name)
                tooltip.onMouseOver(d, this, function(d) {
                    return chart.x1AxisDisplayName + colonAnnotation + formatTime(d.dim2_name) + "<br/>" + "Type"
                        + colonAnnotation + d.dim1_name + "<br/>" + chart.y1AxisDisplayName + colonAnnotation + inrFormatterV2(d.metric1,chart.data.menuId)
                },fontColor);  // Pass the event for positioning
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Use event for updating position
            })
            .on('mouseleave', function() {
                tooltip.onMouseLeave();  // Hide tooltip on mouse leave
            });


        var y1legend = svg.append('g')
            .attr('class', 'legend')
            .selectAll('g')
            .data(sumstat)
            .enter()
            .append('g')
            .attr('transform', function (d, i) {
                var horz = -chart.margin.left; // Adjust as needed
                var vert = i * 40; // Spacing between legend items
                return 'translate(' + horz + ',' + vert + ')';
            });

        y1legend.append('rect')
            .attr('x', chart.width + chart.margin.right - 60)
            .attr('y', 10)
            .attr('width', 25)
            .attr('height', 25)
            .attr('fill', d => metric1ColorScale(d.key));

        y1legend.append('text')
            .data(sumstat, (d) => d.key)
            .attr('x', chart.width + chart.margin.right - 30)
            .attr('y', 23) // Adjust as needed for vertical alignment
            .attr('dy', '0.35em')
            .text((d) => d.key.length > 7 ? d.key.substring(0, 7) + "~ " : d.key)
            .style('font-size', '25px'); // Adjust font size as needed

        var zoomBehaviour = d3.zoom().scaleExtent([1,10]).on("zoom",zoomed);

        // Apply zoom to the SVG
        contentGroup.insert("rect","circle")
            .attr("width",chart.width)
            .attr("height",chart.height)
            .attr("fill","none")
            .attr("pointer-events","all")
            .call(zoomBehaviour);

        function zoomed(){
            var zoomState = d3.zoomTransform(this);

            var newXScale = zoomState.rescaleX(x1Scale);
            var newYScale = zoomState.rescaleY(y1Scale);


            svg.select(".x-axis").call(d3.axisBottom(newXScale)
                .tickFormat(formatTime))
                .selectAll('text')
                .style('font-size', axisLabelFontSize)
                .style('text-anchor', 'end')
                .attr('dx', '-.6em')
                .attr('dy', '-.0em')
                .attr('transform', 'rotate(-60)')

            svg.select(".y-axis").call(d3.axisLeft(newYScale).tickFormat(function (d){
                return inrFormatterV2(d,chart.data.menuId)
            }))
                .selectAll('text')
                .style('font-size', axisLabelFontSize);

            // Update the second line path (if you have more lines)
            contentGroup.selectAll(".line")
                .attr("d", (d) => {
                    let line = d3.line()
                        .x(d => {
                            return newXScale(d.dim2_name)
                        })
                        .y(d => {
                            return newYScale(+d.metric1)
                        })
                    console.log("line from zoom function",line)

                    return line(d.values)
                })

            // Update the circles (dots) to move accordingly
            contentGroup.selectAll(".dot")
                .attr("cx", function (d) {
                    return newXScale(d.dim2_name);
                })
                .attr("cy", function (d) {
                    return newYScale(d.metric1);
                })

        }

    // })
}

